/*
  Offers centralized management of alarm suppression form fields that can be used
  for both alerting 1.0 and 2.0 systems.

  Alerting Manager suppression flows may use an explicit start time or the ASAP timestamp setting.
  Consumers that expose explicit scheduling are responsible for applying their own minimum-delay validation;
  consumers using ASAP may leave the persisted start time unset and let Alerting Manager resolve it.

  Both the start and expiration times are transformed to cut off milliseconds and produce iso date strings

  These form fields are currently used in:
    - silent mode
    - edit test > alerting and notifications
    - agent details maintenance mode
*/

import moment from 'moment';

const fields = {
  startTime: {
    defaultValue: () => moment()
  },

  expirationTime: {
    label: 'Expires',
    defaultValue: () => moment().add(7, 'days')
  },

  neverExpire: {
    defaultValue: false
  }
};

export default fields;
